export const INIT_AUTO_REFRESH = 'AUTH/INIT_AUTO_REFRESH';
export const CHECK_TOKEN = 'AUTH/CHECK_TOKEN';

export const EXECUTE_ACTION_CODE = 'AUTH/EXECUTE_ACTION_CODE';
export const EXECUTE_ERROR_CODE = 'AUTH/EXECUTE_ERROR_CODE';

export const WHO_AM_I_BACKGROUND_START = 'AUTH/WHO_AM_I_BACKGROUND_START';

export const WHO_AM_I_START = 'AUTH/WHO_AM_I_START';
export const WHO_AM_I_SUCCESS = 'AUTH/WHO_AM_I_SUCCESS';
export const WHO_AM_I_FAIL = 'AUTH/WHO_AM_I_FAIL';

export const REFRESH_TOKEN_START = 'AUTH/REFRESH_TOKEN_START';
export const REFRESH_TOKEN_SUCCESS = 'AUTH/REFRESH_TOKEN_SUCCESS';
export const REFRESH_TOKEN_FAIL = 'AUTH/REFRESH_TOKEN_FAIL';

export const ACCUMULATE_ACTION = 'AUTH/ACCUMULATE_ACTION';
export const REALIZE_ACTIONS = 'AUTH/REALIZE_ACTIONS';
export const CLEAN_ACCUMULATOR = 'AUTH/CLEAN_ACCUMULATOR';

export const REDIRECT_TO_AUTH_SERVICE = 'AUTH/REDIRECT_TO_AUTH_SERVICE';
export const REDIRECT_TO_CAS_LOGOUT = 'AUTH/REDIRECT_TO_CAS_LOGOUT';

export const RESET_USER = 'AUTH/RESET_USER';

export const LOGOUT = 'AUTH/LOGOUT';
export const RESET_REDUCERS = 'AUTH/RESET_REDUCERS';
